import { useEffect, useState } from "react";
import { useMoralis, useNativeBalance } from "react-moralis";
import { Link } from 'react-router-dom';
import { Logo, Logo2 } from '../../../assets';
import { BtnLoading, Button } from '../../atoms';
import './Navbar.scss';



const Navbar = () => {
  const [userBalance, setUserBalance] = useState('')
  const { authenticate, isAuthenticated, user, logout, isAuthenticating } = useMoralis()
  const { data: balance } = useNativeBalance()
  const address = (theAddress) => {
    return theAddress.substr(0, 4) + '...' + theAddress.substr(theAddress.length - 4, theAddress.length);
  }

  useEffect(() => {
    setUserBalance(balance.formatted)
  }, [balance])

  const handleAuth = () => {
    authenticate({ signingMessage: "signing in IDM Launchpad" })
  }
  const AuthState = () => {
    if(isAuthenticated){
      return (
        <div className="d-flex">
          <div className="metamask d-none d-md-block">
            <span className="money"><b>{userBalance}</b></span>
            <span className='mx-1'>|</span>
            <span className="acoount-metamask">{address(user.get("ethAddress"))}</span>
          </div>
          <div className="menu-logged-in dropstart ms-2">
            <button className="profile" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown">
              <img className="img" src={Logo2} alt="avatar" />
            </button>
            <ul className="dropdown-menu">
              <li className="dropdown-item d-md-none">
                <span className="acoount-metamask">{address(user.get("ethAddress"))}</span>
              </li>
              <li>
                <button className="dropdown-item" onClick={() => logout()} disabled={isAuthenticating}>Disconnect</button>
              </li>
            </ul>
          </div>
        </div>
      )
    }
    if(isAuthenticating){
      return <BtnLoading />
    }
    return <Button type="link" to="#/" w={150} h={40} className="btn-yellow" title="Connect Wallet" onClick={handleAuth} />
  }

  return (
    <section className="_navbar">
      <div className="container">
        <div className="wrapper">
          <div className="left">
            <Link to="/">
              <img src={Logo} alt="logo" className="logo" />
            </Link>
          </div>
          <div className="right">
          <AuthState />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Navbar
